import { TemplateNodeSchema } from '@ulysses-inc/harami_api_client'

/**
 * 逸脱コメントのデフォルト値。
 * 新規ノード作成時および質問種別変更時のリセットで使用する。
 */
export const DEFAULT_DEVIATE_COMMENT =
  '逸脱しています。責任者に確認してください。'

/**
 * 回答種別の変更時にリセットするべき質問パラメータの型。
 * dispatchUpdateTemplateNode のコールバック引数として使用される。
 */
export type TemplateQuestionResetParams = Pick<
  Partial<NonNullable<TemplateNodeSchema['question']>>,
  | 'responseType'
  | 'responseMultipleChoices'
  | 'responseMultipleChoiceSets'
  | 'responseNumbers'
  | 'responseTexts'
  | 'responseDatetimes'
  | 'responseTimeMeasurements'
  | 'responseInformations'
  | 'responseEmployees'
  | 'responseFormulas'
  | 'responseGridVariables'
  | 'responseLabelChecks'
  | 'responseURLs'
  | 'answerOption'
  | 'deviateComment'
  | 'deviateNotify'
  | 'scale'
  | 'isShowInformationImages'
  | 'informationImages'
>
